import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService } from 'core/services/auth.service';
import { BalanceService } from 'core/services/balance.service';
import { RefreshOnLanguageChangeDirective } from 'shared/directives/refresh-on-language-change.directive';

@Component({
  selector: 'app-metrics-card',
  imports: [TranslatePipe],
  templateUrl: './metrics-card.component.html',
  styleUrl: './metrics-card.component.scss',
  hostDirectives: [RefreshOnLanguageChangeDirective]
})
export class MetricsCardComponent {
  authService = inject(AuthService);
  balanceService = inject(BalanceService);
  currentUser = this.authService.currentUser$;

  get totalLeaves(): number {
    return this.currentUser()?.leaves ?? 0;
  }

  get growingGanas(): number {
    return this.currentUser()?.balance?.potential || 0;
  }

  get availableGanas(): number {
    return this.balanceService.balanceGanas();
  }
}
